import { AppBar, Stack, Button } from "@mui/material";
import { useTheme } from "@mui/material/styles";
import { useRecoilValue, useRecoilState } from "recoil";
import { authState } from "../recoil/authState";
import { contractModalState } from "../recoil/contractModalState";
import { useNavData, useBottomNavData } from "./navData";
import { NAV } from "./config-layout";
import Breadcrumb from "./header/Breadcrumb";
import GuideToggle from "./header/GuideToggle";
import UserMenu from "./header/UserMenu";
import ContractModal from "../component/ContractModal";
import { trackUiClick } from "../analytics/analytics";

export default function Header() {
  const theme = useTheme();
  const topNavData = useNavData();
  const bottomNavData = useBottomNavData();
  const auth = useRecoilValue(authState);
  const [contractModalOpen, setContractModalOpen] = useRecoilState(contractModalState);

  return (
    <AppBar
      sx={{
        height: "60px",
        display: "flex",
        alignItems: "center",
        flexDirection: "row",
        padding: "15px",
        zIndex: theme.zIndex.appBar + 1,
        bgcolor: "#FDFDFD",
        width: `calc(100% - ${NAV.WIDTH + 1}px)`,
      }}
    >
      <Stack
        display={"flex"}
        flex={1}
        flexDirection={"row"}
        justifyContent={"space-between"}
      >
        <Stack flex={1}>
          <Breadcrumb navData={[...topNavData, ...bottomNavData]} />
        </Stack>
        <Stack
          display={"flex"}
          flexDirection={"row"}
          alignItems={"center"}
          gap={2}
        >
          <GuideToggle />
          <Button
            onClick={() => {
              trackUiClick({
                ui_target_key: 'golf_contract_document',
                element_id: 'contract-button-header',
                element_text: '골프대행 계약서',
                ui_target_text: '골프대행 계약서',
                ui_area: 'header',
              });
              setContractModalOpen(true);
            }}
            variant="contained"
            sx={{
              color: "#fff",
              bgcolor: theme.palette.primary.main,
              fontSize: "14px",
              fontWeight: "bold",
              textTransform: "none",
              py: 0.75,
              px: 1.5,
              "&:hover": {
                color: "#000",
                bgcolor: "#fff",
              },
            }}
          >
            골프대행 계약서
          </Button>
          <Stack
            sx={{
              color: theme.palette.common.darkGrey,
              fontSize: "16px",
              fontWeight: "bold",
              lineHeight: 1,
            }}
          >
            {auth.user.club_admin_id}
          </Stack>
          <UserMenu />
        </Stack>
      </Stack>
      
      {/* 전자계약서 모달 */}
      <ContractModal 
        open={contractModalOpen}
        onClose={() => setContractModalOpen(false)}
      />
    </AppBar>
  );
}
